import React, { useState } from 'react'
import { connect } from 'react-redux'
import Modal from '../modal'
import LoginPage from '../../containers/logInPage'
import SignUpForm from '../../components/signUpForm'
import {
  loginDesktopStyle,
  loginMobileStyle,
  signUpDesktopStyle,
  signUpMobileStyle,
  signUpSmallMobileStyle,
} from './style'

const ModalLogin = ({
  isOpen,
  location,
  setOpenModal,
  isMobile,
  maxHeight,
  signUp,
  hideResetPassword,
  shownXclose,
}) => {
  const [typeModal, setTypeModal] = useState('login')
  const mobile = isMobile.matches
  const responsiveMobile = () => {
    if (mobile) {
      if (maxHeight.matches) {
        return signUpSmallMobileStyle.content
      } else {
        return signUpMobileStyle.content
      }
    } else {
      return signUpDesktopStyle.content
    }
  }
  const contentStyle = {
    login: mobile ? loginMobileStyle.content : loginDesktopStyle.content,
    signup: responsiveMobile(),
  }

  const handleSubmit = async (values) => {
    await signUp(values)
    setTypeModal('login')
  }

  return (
    <Modal
      isOpen={isOpen}
      contentStyle={contentStyle[typeModal]}
      overlayStyle={{ zIndex: 1 }}
      shownXclose={shownXclose}
      onRequestClose={() => setOpenModal(false)}
      onClickClose={() => setOpenModal(false)}
    >
      <div style={{ margin: '48px 0px 24px 0px' }}>
        {typeModal === 'login' ? (
          <LoginPage
            location={location}
            setOpenModal={setOpenModal}
            setTypeModal={setTypeModal}
            hideResetPassword={hideResetPassword}
            isModal
          />
        ) : (
          <SignUpForm isModal={isOpen} onSubmit={handleSubmit} setTypeModal={setTypeModal} />
        )}
      </div>
    </Modal>
  )
}

const mapState = (state) => ({
  appUser: state.AppUser,
})
const mapDispatch = (dispatch) => {
  const {
    AppUser: { signUp },
  } = dispatch
  return {
    signUp,
  }
}
export default connect(mapState, mapDispatch)(ModalLogin)
